// src/Pages/Load/LoadContainer/utils/jwt.js

/**
 * Decodifica um JWT sem validar assinatura (somente leitura do payload).
 * Mantém compatibilidade com o decode atual, mas aceita base64url também.
 */
export const decodeJWT = (token) => {
  try {
    if (!token || typeof token !== "string") return null;

    const parts = token.split(".");
    if (parts.length < 2) return null;

    // payload é base64url
    let payload = parts[1];

    // converte base64url -> base64
    payload = payload.replace(/-/g, "+").replace(/_/g, "/");

    // padding
    const pad = payload.length % 4;
    if (pad) payload += "=".repeat(4 - pad);

    const decodedPayload = atob(payload);
    return JSON.parse(decodedPayload);
  } catch (error) {
    console.error("Erro ao decodificar JWT:", error);
    return null;
  }
};

/**
 * Mantém o comportamento original:
 * - coloca window.userRoleId
 * - retorna o user_role_id ou null
 */
export const setUserRoleIdOnWindow = (token) => {
  const decodedData = decodeJWT(token);

  if (decodedData && decodedData.user_role_id) {
    window.userRoleId = decodedData.user_role_id;
    return decodedData.user_role_id;
  }

  return null;
};